import React from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { CoursePollWithQuestionsResponse } from '../../../../../api/types/students/course-poll-feedbacks/course-poll-with-questions';

export interface FeedbackPollCardProps {
  poll: CoursePollWithQuestionsResponse;
  onClick: () => void;
}

export const FeedbackPollCard: React.FC<FeedbackPollCardProps> = ({
  poll,
  onClick,
}) => {
  const questionsCount = poll.questions?.length || 0;
  const isSubmitted = poll.hasSubmitted || false;

  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
        padding: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        cursor: isSubmitted ? 'default' : 'pointer',
        transition: 'all 0.2s ease',
        opacity: isSubmitted ? 0.7 : 1,
      }}
      onClick={isSubmitted ? undefined : onClick}
      onMouseEnter={(e) => {
        if (!isSubmitted) {
          e.currentTarget.style.borderColor = '#3b82f6';
          e.currentTarget.style.boxShadow =
            '0 4px 12px rgba(59, 130, 246, 0.15)';
        }
      }}
      onMouseLeave={(e) => {
        if (!isSubmitted) {
          e.currentTarget.style.borderColor = '#e5e7eb';
          e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)';
        }
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        {/* Poll Info */}
        <div style={{ flex: 1 }}>
          {/* Course Name */}
          <div
            style={{
              fontSize: '13px',
              color: '#6b7280',
              marginBottom: '4px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            <i className="pi pi-book" style={{ fontSize: '12px' }} />
            {poll.courseName}
          </div>

          {/* Poll Name */}
          <div
            style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#1f2937',
              marginBottom: '12px',
            }}
          >
            {poll.pollName}
          </div>

          {/* Tags */}
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Tag
              value={`${questionsCount} שאלות`}
              severity="info"
              style={{ fontSize: '12px' }}
            />
            {poll.isAnonymous && (
              <Tag
                value="משוב אנונימי"
                severity="secondary"
                style={{ fontSize: '12px' }}
              />
            )}
            {isSubmitted ? (
              <Tag
                value="הושלם"
                severity="success"
                style={{ fontSize: '12px' }}
              />
            ) : (
              poll.blockGradeView && (
                <Tag
                  value="נדרש למילוי"
                  severity="warning"
                  style={{ fontSize: '12px' }}
                />
              )
            )}
          </div>
        </div>

        {/* Action Button */}
        <Button
          label={isSubmitted ? 'הושלם' : 'מלא משוב'}
          icon={isSubmitted ? 'pi pi-check' : 'pi pi-pencil'}
          className={isSubmitted ? 'p-button-success' : 'p-button-primary'}
          disabled={isSubmitted}
          onClick={(e) => {
            e.stopPropagation();
            if (!isSubmitted) {
              onClick();
            }
          }}
        />
      </div>
    </div>
  );
};
